<template>
  <div class="tw-w-full">
    <div class="tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50 tw-p-2 sm:tw-p-3">
      <SearchInput
        v-model="searchTerm"
        placeholder="Container Number, BL or Customer Name"
        class="tw-w-full"
      ></SearchInput>

    <Modal v-model:isOpen="isDispatchContainerOpen" modalId="daily-dispatch-container-modal" maxWidth="7xl" :hasCloseButton="false" @close="closeDispatchContainer">
      <template #title>Dispatch</template>
      <template #content>
        <div class="tw--m-5">
          <DispatchContainerModal
            :containerId="selectedContainerId"
            @dispachContainerRefetch="updateDispatchContainers"
            :drivers="drivers"
            @close="closeDispatchContainer"
          ></DispatchContainerModal>
        </div>
      </template>
    </Modal>
      <div class="tw-mt-2 tw-border-t tw-border-slate-200/70 tw-pt-2">
        <div class="tw-min-w-0 tw-overflow-x-auto">
          <div class="tw-flex tw-flex-nowrap tw-items-center tw-gap-2 tw-whitespace-nowrap">
            <ul class="tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap">
              <li @click.prevent="updateDispatchFilter('all')">
                <a
                  href="#"
                  class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                  :class="dispatchPeriod === 'all'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                >All</a>
              </li>
              <li @click.prevent="updateDispatchFilter('today')">
                <a
                  href="#"
                  class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                  :class="dispatchPeriod === 'today'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                >Today</a>
              </li>
              <li @click.prevent="updateDispatchFilter('tomorrow')">
                <a
                  href="#"
                  class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                  :class="dispatchPeriod === 'tomorrow'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                >Tomorrow</a>
              </li>
              <li @click.prevent="updateDispatchFilter('dayAfter')">
                <a
                  href="#"
                  class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                  :class="dispatchPeriod === 'dayAfter'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                >Day after</a>
              </li>
              <li @click.prevent="updateDispatchFilter('nextWeek')">
                <a
                  href="#"
                  class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                  :class="dispatchPeriod === 'nextWeek'
                    ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                >Next week</a>
              </li>
            </ul>

            <span class="tw-text-slate-300">|</span>

            <div
              v-if="!isShowingAppointments"
              uk-switcher="animation: uk-animation-fade; toggle: > *; connect: .trip-switcher"
              class="tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap"
            >
              <button
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                type="button"
                :class="activeTripFilterIdx === 0
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                @click="activeTripFilterIdx = 0"
              >
                In Progress
                <span class="tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-emerald-500/15 tw-px-2 tw-py-0.5 tw-text-xs tw-text-emerald-800">{{ inProgressTrips.length }}</span>
              </button>
              <button
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                type="button"
                :class="activeTripFilterIdx === 1
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                @click="activeTripFilterIdx = 1"
              >
                Not started
                <span class="tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700">{{ notStartedTrips.length }}</span>
              </button>
              <button
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                type="button"
                :class="activeTripFilterIdx === 2
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                @click="activeTripFilterIdx = 2"
              >
                Driver not assigned
                <span class="tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-rose-500/15 tw-px-2 tw-py-0.5 tw-text-xs tw-text-rose-800">{{ driverNotAssignedTrips.length }}</span>
              </button>
              <button
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                type="button"
                :class="activeTripFilterIdx === 3
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                @click="activeTripFilterIdx = 3"
              >
                Chassis not assigned
                <span class="tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-rose-500/15 tw-px-2 tw-py-0.5 tw-text-xs tw-text-rose-800">{{ chassisNotAssignedTrips.length }}</span>
              </button>

              <button
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                type="button"
                :class="activeTripFilterIdx === 4
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                @click="activeTripFilterIdx = 4"
              >
                Completed Moves
                <span class="tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700">{{ completedTrips.length }}</span>
              </button>
              <button
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                type="button"
                :class="activeTripFilterIdx === 5
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                @click="activeTripFilterIdx = 5"
              >
                All Moves
                <span class="tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700">{{ dailyTrips.length }}</span>
              </button>
            </div>
            <div
              v-else
              uk-switcher="animation: uk-animation-fade; toggle: > *; connect: .trip-appt-switcher"
              class="tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap"
            >
              <button
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                type="button"
                :class="activeApptFilterIdx === 0
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                @click="activeApptFilterIdx = 0"
              >
                <HourGlass />
                Terminal Appointments
                <span class="tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700">{{ terminalApptTrips.length }}</span>
              </button>
              <button
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-backdrop-blur"
                type="button"
                :class="activeApptFilterIdx === 1
                  ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                  : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                @click="activeApptFilterIdx = 1"
              >
                <EventSchedule />
                Delivery Appointments
                <span class="tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700">{{ deliveryApptTrips.length }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-mt-3 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50">
      <ul class="uk-switcher uk-margin trip-switcher" v-if="!isShowingAppointments">
        <li>
          <daily-dispatch-table
            @updateContainers="updateDispatchContainers"
            :drivers="drivers"
            :trips="inProgressTrips"
            @selectTrip="selectTrip"
          ></daily-dispatch-table>
        </li>
        <li>
          <daily-dispatch-table
            @updateContainers="updateDispatchContainers"
            :drivers="drivers"
            :trips="notStartedTrips"
            @selectTrip="selectTrip"
          ></daily-dispatch-table>
        </li>
        <li>
          <daily-dispatch-table
            @updateContainers="updateDispatchContainers"
            :trips="driverNotAssignedTrips"
            :drivers="drivers"
            @selectTrip="selectTrip"
          ></daily-dispatch-table>
        </li>
        <li>
          <daily-dispatch-table
            @updateContainers="updateDispatchContainers"
            :drivers="drivers"
            :trips="chassisNotAssignedTrips"
            @selectTrip="selectTrip"
          ></daily-dispatch-table>
        </li>

        <li>
          <daily-dispatch-table
            @updateContainers="updateDispatchContainers"
            :trips="completedTrips"
            @selectTrip="selectTrip"
            :drivers="drivers"
          ></daily-dispatch-table>
        </li>
        <li>
          <daily-dispatch-table
            @updateContainers="updateDispatchContainers"
            :trips="dailyTrips"
            @selectTrip="selectTrip"
            :drivers="drivers"
          ></daily-dispatch-table>
        </li>
      </ul>
      <ul class="uk-switcher uk-margin trip-appt-switcher" v-else>
        <li>
          <daily-dispatch-table
            @updateContainers="updateDispatchContainers"
            :drivers="drivers"
            :trips="terminalApptTripsNotComplete"
            :tripsCompleted="terminalApptTripsComplete"
            :appointmentsView="true"
            :terminalAppt="true"
            @selectTrip="selectTrip"
          ></daily-dispatch-table>
        </li>
        <li>
          <daily-dispatch-table
            @updateContainers="updateDispatchContainers"
            :drivers="drivers"
            :appointmentsView="true"
            :deliveryAppt="true"
            :trips="deliveryApptTrips"
            @selectTrip="selectTrip"
          ></daily-dispatch-table>
        </li>
      </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import moment from 'moment';
import Button from '@/components/core/Button.vue';
import HourGlass from '@carbon/icons-vue/es/hourglass/24';
import EventSchedule from '@carbon/icons-vue/es/event--schedule/24';
import sort from 'fast-sort';

import EditTripStatus from '@/gql/orders/trips/mutations/EditTripStatus.gql';
import DispatchContainers from '../../gql/dispatch/DispatchContainers.gql';
import DriversQuery from '../../gql/drivers/Drivers.gql';
import AddTripAfterMutation from '../../gql/dispatch/AddTrip.gql';
import EditTripMutation from '../../gql/dispatch/EditTrip.gql';
import CancelTripMutation from '../../gql/orders/trips/mutations/CancelTrip.gql';
import DailyDispatchTable from './DailyDispatchTable.vue';
import DispatchContainerModal from './DispatchContainerModal.vue';
import SearchInput from '../core/SearchInput.vue';
import Modal from '@/components/core/Modal/Modal.vue';

export default defineComponent({
  components: {
    DailyDispatchTable,
    DispatchContainerModal,
    SearchInput,
    HourGlass,
    EventSchedule,
    Modal,
  },
  props: {
    isShowingAppointments: { default: false },
  },
  data(): any {
    return {
      searchTerm: '',
      selectedContainerId: -1,
      drivers: [] as any[],
      tripAdditionContainer: undefined,
      dispatchPeriod: 'all',
      activeTripFilterIdx: 0,
      activeApptFilterIdx: 0,
      editingTrip: {
        id: undefined,
        afterLegId: undefined,
        type: undefined,
        origin: undefined,
        destination: undefined,
        driver: undefined,
        chassis: undefined,
        isEditingDriver: false,
        isEditingChassis: false,
        isEditingDestination: false,
      },
      //   isAddingTrip: false,
    };
  },
  methods: {
    updateDispatchFilter(dispatchPeriod) {
      (this as any).dispatchPeriod = dispatchPeriod;
    },
    selectTrip(containerId: number | string) {
      (this as any).selectedContainerId = containerId;
    },
    closeDispatchContainer() {
      (this as any).selectedContainerId = -1;
    },
    updateDispatchContainers() {
      (this as any).$apollo.queries.dispatchContainers.refetch();
    },
    printDispatchURL(containerIdx, tripId) {
      return `/print/order/dispatch/${0}/container/${containerIdx}/trip/${tripId}`;
    },
    addTripAfter(trip, containerId) {
      const vm = (this as any);

      vm.tripAdditionContainer = containerId;
      vm.editingTrip.afterLegId = trip.legId;
      vm.editingTrip.origin = trip.destination;
      vm.editingTrip.driver = trip.driver;
      vm.editingTrip.chassis = trip.chassis;
    },
    confirmAddTripAfter(containerId, orderId) {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: AddTripAfterMutation,
          variables: {
            containerId,
            orderId,
            afterLegId: vm.editingTrip.afterLegId,
            tripType: vm.editingTrip.type,
            origin: vm.editingTrip.origin,
            destination: vm.editingTrip.destination,
            driver: vm.editingTrip.driver,
            chassis: vm.editingTrip.chassis,
          },
        })
        .then((data) => {
          vm.tripAdditionContainer = undefined;
          vm.updateDispatchContainers();
        })
        .catch((err) => {
          console.error(err);
          vm.updateDispatchContainers();
        });
    },
    completeTrip(trip) {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: EditTripStatus,
          variables: {
            tripId: Number(trip.id),
            status: 'Complete',
          },
        })
        .then(() => {
          // (this as any).$emit('refreshOrders');
          vm.updateDispatchContainers();
          vm.editingTrip.id = undefined;
        });
    },
    cancelTripAddition() {
      const vm = (this as any);

      vm.tripAdditionContainer = undefined;
      vm.editingTrip.afterLegId = undefined;
    },

    cancelTrip(trip) {
      (this as any).$apollo
        .mutate({
          mutation: CancelTripMutation,
          variables: {
            tripId: trip.id,
          },
        })
        .then(() => {
          this.updateDispatchContainers();
        });
    },
    startTrip(trip) {
      const vm = (this as any);

      (this as any).$apollo
        .mutate({
          mutation: EditTripStatus,
          variables: {
            tripId: Number(trip.id),
            status: 'In Progress',
          },
        })
        .then(() => {
          vm.$apollo.queries.dispatchContainers.refetch();
          (this as any).editingTrip.id = undefined;
        });
    },
    toggleAppointmentsView() {
      const vm = (this as any);

      vm.isShowingAppointments = !vm.isShowingAppointments;
    },
    editTrip(trip) {
      (this as any).editingTrip.id = trip.id;
    },
    saveTrip(trip) {
      const vm = (this as any);

      const chassis = trip.chassis || '';
      vm.$apollo
        .mutate({
          mutation: EditTripMutation,
          variables: {
            tripId: Number(trip.id),
            tripType: trip.tripType,
            origin: trip.origin,
            destination: trip.destination,
            driver: trip.driver,
            chassis,
          },
        })
        .then(() => {
          vm.editingTrip.id = undefined;
        })
        .catch((err) => {
          vm.editingTrip.id = undefined;
        });

      // Send mutation
      console.log(`saved trip data ${JSON.stringify(trip)}`);
    },
  },
  computed: {
    isDispatchContainerOpen: {
      get(): boolean {
        return (this as any).selectedContainerId !== -1;
      },
      set(value: boolean) {
        if (!value) {
          (this as any).closeDispatchContainer();
        }
      },
    },
    // sortedTrips() {},
    dailyTrips(): any[] {
      const vm = (this as any);

      const trips = [];

      vm.filteredContainers.forEach((container) => {
        container.trips.forEach((trip) => {
          const newTrip = {
            ...(trip as any),
            container,
          };
          if (vm.dispatchPeriod === 'all') {
            trips.push(newTrip);
          } else if (vm.dispatchPeriod === 'today' && newTrip.scheduledDate) {
            const scheduled = moment(newTrip.scheduledDate);
            if (scheduled.isSame(moment.now(), 'day')) {
              trips.push(newTrip);
            }
          } else if (
            vm.dispatchPeriod === 'tomorrow' &&
            newTrip.scheduledDate
          ) {
            const scheduled = moment(newTrip.scheduledDate);
            if (scheduled.isSame(moment().add(1, 'days'), 'day')) {
              trips.push(newTrip);
            }
          } else if (
            vm.dispatchPeriod === 'dayAfter' &&
            newTrip.scheduledDate
          ) {
            const scheduled = moment(newTrip.scheduledDate);
            if (scheduled.isSame(moment().add(2, 'days'), 'day')) {
              trips.push(newTrip);
            }
          } else if (
            vm.dispatchPeriod === 'nextWeek' &&
            newTrip.scheduledDate
          ) {
            const scheduled = moment(newTrip.scheduledDate);
            if (scheduled.isAfter(moment().startOf('isoWeek').add(1, 'week'))) {
              trips.push(newTrip);
            }
          }
        });
      });

      return trips;
    },
    driverNotAssignedTrips(): any[] {
      const vm = (this as any);

      return vm.dailyTrips.filter((x) => {
        return x.status !== 'Complete' && !x.driver;
      });
    },
    notStartedTrips(): any[] {
      const vm = (this as any);

      return vm.dailyTrips.filter((x) => {
        return x.status !== 'In Progress' && x.status !== 'Complete';
      });
    },
    completedTrips(): any[] {
      const vm = (this as any);

      return vm.dailyTrips.filter((x) => {
        return x.status === 'Complete';
      });
    },
    inProgressTrips(): any[] {
      const vm = (this as any);

      return vm.dailyTrips.filter((x) => {
        return x.status === 'In Progress';
      });
    },
    chassisNotAssignedTrips(): any[] {
      const vm = (this as any);

      return vm.dailyTrips.filter((x) => {
        return x.status !== 'Complete' && !x.chassis;
      });
    },
    terminalApptTrips(): any[] {
      const vm = (this as any);

      return vm.dailyTrips.filter((x) => {
        return x.container.terminalAppointmentDate && x.tripType === 'Full Out';
      });
    },
    terminalApptTripsNotComplete(): any[] {
      return sort(
        (this as any).dailyTrips.filter((x) => {
          return (
            x.container.terminalAppointmentDate &&
            x.tripType === 'Full Out' &&
            x.status !== 'Complete'
          );
        }),
      ).asc((x: any) => x.container.terminalAppointmentDate);
    },
    terminalApptTripsComplete(): any[] {
      return sort(
        (this as any).dailyTrips.filter((x) => {
          return (
            x.container.terminalAppointmentDate &&
            x.tripType === 'Full Out' &&
            x.status === 'Complete'
          );
        }),
      ).asc((x: any) => x.container.terminalAppointmentDate);
    },
    deliveryApptTrips(): any[] {
      return sort(
        (this as any).dailyTrips.filter((x) => {
          return (
            x.container.deliveryAppointmentDate &&
            (x.tripType.includes('Drop') || x.tripType.includes('Live'))
          );
        }),
      ).asc((x: any) => x.container.deliveryAppointmentDate);
    },
    completedContainers(): any[] {
      const vm = (this as any);

      const dispatchContainers = Array.isArray(vm.dispatchContainers)
        ? vm.dispatchContainers
        : vm.dispatchContainers && Array.isArray(vm.dispatchContainers.containers)
        ? vm.dispatchContainers.containers
        : [];

      if (!dispatchContainers) {
        return [];
      }

      return dispatchContainers.filter((x) =>
        x.trips.reduce((acc, trip) => {
          if (!acc) {
            return acc;
          } else if (trip.status === 'Complete') {
            return true;
          } else {
            return false;
          }
        }, true),
      );
    },
    currentStopsForContainers(): any[] {
      const vm = (this as any);

      const dispatchContainers = Array.isArray(vm.dispatchContainers)
        ? vm.dispatchContainers
        : vm.dispatchContainers && Array.isArray(vm.dispatchContainers.containers)
        ? vm.dispatchContainers.containers
        : [];

      if (!dispatchContainers) {
        return [];
      }

      return vm.containersInProgress.map((container, containerIdx) => {
        const trips = vm.sortedTripsForContainers[containerIdx];
        if (!trips[0]) {
          return 0;
        }

        return trips.reduce((acc, trip) => {
          if (trip.status === 'Complete') {
            return acc + 1;
          }
          return acc;
        }, 0);
      });
    },

    sortedTripsForContainers(): any[] {
      return (this as any).containersInProgress.map((container) => {
        return container.trips.sort((a, b) => {
          return a.legId - b.legId;
        });
      });
    },
    stopsForContainer(): any[] {
      return (this as any).containersInProgress.map((container, containerIdx) => {
        const trips = this.sortedTripsForContainers[containerIdx];
        let origin = trips[0].origin;
        if (!origin || origin === '') {
          origin = 'origin unknown';
        }
        const stops = [origin];
        console.log(`stops are ${stops}`);
        const destinations = trips.map((x) => {
          if (x.destination) {
            return x.destination;
          } else {
            return 'Destination Unkown';
          }
        });
        console.log(`dest are ${destinations}`);
        return stops.concat(destinations);
      });
    },

    filteredContainers(): any[] {
      const vm = (this as any);
      const dispatchContainers = Array.isArray(vm.dispatchContainers)
        ? vm.dispatchContainers
        : vm.dispatchContainers && Array.isArray(vm.dispatchContainers.containers)
        ? vm.dispatchContainers.containers
        : [];

      if (!dispatchContainers) {
        return [];
      }

      if (vm.searchTerm.length === 0) {
        return dispatchContainers;
      } else {
        return dispatchContainers.filter((x) => {
          return (
            (x.order.bookingNumber &&
              x.order.bookingNumber.includes(vm.searchTerm)) ||
            (x.order.id && x.order.id.includes(vm.searchTerm)) ||
            (x.order.billOfLading &&
              x.order.billOfLading.billOfLadingId.includes(
                vm.searchTerm.toUpperCase(),
              )) ||
            (x.order.receiver &&
              x.order.receiver.name &&
              x.order.receiver.name
                .toLowerCase()
                .includes(vm.searchTerm.toLowerCase())) ||
            x.containerId
              .toLowerCase()
              .includes(vm.searchTerm.toLowerCase()) ||
            x.trips.reduce((acc, trip) => {
              if (acc) {
                return acc;
              }

              if (
                trip.driver &&
                trip.driver.fullName
                  .toLowerCase()
                  .includes(vm.searchTerm.toLowerCase())
              ) {
                return true;
              }

              if (
                trip.chassis &&
                trip.chassis
                  .toLowerCase()
                  .includes(vm.searchTerm.toLowerCase())
              ) {
                return true;
              }

              return false;
            }, false)
          );
        });
      }
    },

    containersInProgress(): any[] {
      const vm = (this as any);
      const dispatchContainers = Array.isArray(vm.dispatchContainers)
        ? vm.dispatchContainers
        : vm.dispatchContainers && Array.isArray(vm.dispatchContainers.containers)
        ? vm.dispatchContainers.containers
        : [];

      if (!dispatchContainers) {
        return [];
      }

      return dispatchContainers.filter(
        (x) =>
          x.trips.length > 0 &&
          !x.trips.reduce((acc, trip) => {
            if (!acc) {
              return acc;
            } else if (trip.status === 'Complete') {
              return true;
            } else {
              return false;
            }
          }, true),
      );
    },
  },
  apollo: {
    dispatchContainers: {
      query: DispatchContainers,
    },
    drivers: {
      query: DriversQuery,
      skip() {
        return (this as any).selectedContainerId === -1;
      },
    },
  },
});
</script>
